import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import './PopupLoading.css';

const PopupLoading = () => {
  return <div className="popup_loading"> 
    <div className="popup_content">
      <div className="icon"><ReactSVG src="assets/images/logo_white.svg" /></div>
      {/*<h2>{i18n.t('loading')}</h2>*/}
    </div>
  </div>;
};

export default PopupLoading;